import React from "react";
import styles from "./KnowledgeCard.module.scss";
import { Box, Chip, Typography } from "@mui/material";
import DocumentIcon from "../icon-components/DocumentIcon";
import { useTranslation } from "react-i18next";
import PlayButtonIcon from "../icon-components/PlayButtonIcon";
import NoImageThumbnail from "../../assets/icons/learning_no_image.svg";
import AudioIcon from "../icon-components/AudioIcon";

interface KnowledgeCardProps {
  contentType: string;
  imageSrc: string;
  imageAlt?: string;
  isNew?: boolean;
  title: string;
  height?: string;
  width?: string;
  length?: string;
  isAudio?: boolean;
  onClick?: () => void;
}

const KnowledgeCard: React.FC<KnowledgeCardProps> = ({
  contentType,
  imageSrc,
  imageAlt = "Thumbnail",
  isNew = false,
  title,
  height,
  width,
  length,
  isAudio,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      className={styles.cardContainer}
      height={height}
      width={width}
      onClick={onClick}
      sx={{ cursor: onClick ? "pointer" : "default" }}
    >
      <Box className={styles.imageSection}>
        {isNew && (
          <Chip
            label={t("educationContent.new")}
            className={styles.newChip}
          />
        )}
        <img
          src={imageSrc || NoImageThumbnail}
          alt={imageAlt}
          className={imageSrc ? styles.thumbnailImage : styles.noThumbnailImage}
        />
      </Box>

      <Box className={styles.cardContent}>
        <Box
          display="flex"
          alignItems="center"
          className={styles.videoInfo}
        >
          {contentType === "articles" ? (
            <>
              <DocumentIcon
                width={16}
                height={17}
                fill="#4E7E6E"
              />
              <Typography
                variant="body2"
                className={styles.videoText}
              >
                {t("article")}
              </Typography>
              {isAudio && (
                <>
                  <Typography
                    variant="body2"
                    className={styles.videoText}
                  >
                    |
                  </Typography>
                  <AudioIcon
                    style={{ fontSize: "16px", verticalAlign: "middle" }}
                  />
                  <Typography
                    variant="body2"
                    className={styles.videoText}
                  >
                    {t("educationContent.audio")}
                  </Typography>
                </>
              )}
            </>
          ) : (
            <>
              <PlayButtonIcon
                width={16}
                height={17}
                fill="#4E7E6E"
              />
              <Typography
                variant="body2"
                className={styles.videoText}
              >
                {t("video")} {length}
              </Typography>
            </>
          )}
        </Box>
        <Typography
          variant="body1"
          className={styles.titleText}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default KnowledgeCard;
